import { settingsStore } from '@/lib/settingsStore';

// ============================================================================
// chatDrafts.ts — ЧЕРНОВИКИ СООБЩЕНИЙ (единый механизм, на пользователя):
//   - текст черновика хранится в user_settings по ключу
//     `chat.draft.<conversationId>` (SSoT — сервер: переживает перезагрузку
//     и доступен с других устройств пользователя);
//   - пустой текст — КЛЮЧ УДАЛЯЕТСЯ (пустые записи не копятся);
//   - сохраняется ТОЛЬКО текст: вложения и ответ (цитата) черновиком НЕ являются;
//   - запись гейтится гидрацией настроек: hydrate() очищает кэш и заполняет его
//     снапшотом сервера — до неё запись небезопасна (значение может быть затёрто).
// ============================================================================

/** Префикс ключей черновиков в user_settings (SSoT — сервер). */
export const CHAT_DRAFT_KEY_PREFIX = 'chat.draft.';

/** Ключ черновика чата. */
export function chatDraftKey(conversationId: string): string {
  return CHAT_DRAFT_KEY_PREFIX + conversationId;
}

/** Текст черновика чата ('' — черновика нет или настройки ещё не гидратированы). */
export function loadChatDraft(conversationId: string): string {
  const stored = settingsStore.get(chatDraftKey(conversationId));
  return stored === undefined ? '' : stored;
}

/**
 * Сохранение черновика: пустой текст удаляет ключ; неизменившееся значение
 * на сервер не отправляется. До гидрации настроек запись пропускается
 * (saveChatDraft вызовут снова при следующем вводе/уходе после гидрации).
 */
export function saveChatDraft(conversationId: string, text: string): void {
  if (!settingsStore.isHydrated()) return;
  const key = chatDraftKey(conversationId);
  const current = settingsStore.get(key) ?? '';
  const next = text.trim() === '' ? '' : text;
  if (current === next) return;
  if (next === '') {
    settingsStore.remove(key);
    return;
  }
  settingsStore.set(key, next);
}

/** Подписка на изменения черновиков (гидрация + запись) — живое обновление списка чатов. */
export function subscribeChatDrafts(fn: () => void): () => void {
  return settingsStore.subscribe(fn);
}
